import React from 'react';

import { YesNoOrgProfileQuestion } from 'features/coordinator/enroll/components/YesNoOrgProfileQuestion';

export const inPersonQuestion = 'Does your organization meet in person on a regular basis?';

export const OrgProfileQuestion2 = () => (
    <YesNoOrgProfileQuestion question={inPersonQuestion} progressStep={[3, 5]} />
);
